import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  breadcrumbs?: Array<{ label: string; href?: string }>;
}

export default function PageHeader({ title, subtitle, breadcrumbs }: PageHeaderProps) {
  return (
    <Box
      sx={{
        mb: 4,
        pb: 3,
        borderBottom: 2,
        borderColor: 'primary.main',
      }}
    >
      {breadcrumbs && breadcrumbs.length > 0 && (
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          sx={{ mb: 2 }}
          aria-label="breadcrumb"
        >
          <Link
            underline="hover"
            sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
            color="inherit"
            href="/"
          >
            <HomeIcon fontSize="small" />
            Início
          </Link>
          {breadcrumbs.map((crumb, index) =>
            crumb.href ? (
              <Link key={index} underline="hover" color="inherit" href={crumb.href}>
                {crumb.label}
              </Link>
            ) : (
              <Typography key={index} color="text.primary">
                {crumb.label}
              </Typography>
            )
          )}
        </Breadcrumbs>
      )}

      <Typography
        variant="h1"
        component="h1"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          fontWeight: 700,
          color: 'primary.main',
          mb: subtitle ? 1 : 0,
        }}
      >
        {title}
      </Typography>

      {subtitle && (
        <Typography variant="body1" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
